import { Dispatch } from "redux";
import { Action } from "api/action_types/sketch";
import { ActionType } from "api/action_types/sketch";
import { Sink } from "api/types/sketch";

export const createLocalSink = (sink: Sink) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CREATE_LOCAL_SINK,
            payload: sink
        });
    }
}